<script lang="ts">
	import { onMount, type Snippet } from 'svelte';
	import { convertRange } from '$lib/utils/number';

	interface Props {
		offset?: number;
		class?: string;
		children?: Snippet;
	}

	let { offset = 20, class: className, children }: Props = $props();

	let wrapper: HTMLDivElement;
	let section: HTMLDivElement;

	let wrapperHeight = $state(0);
	let translateX = $state(0);

	const handleScroll = () => {
		requestAnimationFrame(() => {
			translateX = -convertRange(
				window.scrollY - wrapper.offsetTop,
				0,
				wrapper.offsetHeight - window.innerHeight - offset,
				0,
				section.scrollWidth - wrapper.clientWidth + offset
			);
		});
	};

	const setSectionHeight = () => {
		wrapperHeight = section.scrollWidth;
	};

	onMount(() => {
		setSectionHeight();
	});
</script>

<svelte:window onscroll={handleScroll} onresize={setSectionHeight} />

<div style="height: {wrapperHeight}px" bind:this={wrapper}>
	<div
		bind:this={section}
		class="sticky w-full {className || ''}"
		style="transform: translate3d({translateX}px, 0, 0); top: calc(var(--header-height) + var(--banner-height));"
	>
		{@render children?.()}
	</div>
</div>
